import { Component, Input, ViewChild } from '@angular/core';
import { GlobalMessageClientService } from '../../../../services/client/global-message-client-service/global-message-client.service';
import { MessageActionButtonTypeEnum, MessageModel, MessageSeverity, MessageTypeEnum } from '../message.model';
import { BasicButtonIconColor } from "../../button/basic-button/basic-button.component";
import { ButtonSize, ButtonStyle } from '../../../globals/button/button.enum';
import { filter, Observable } from 'rxjs';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { SuccessIconComponent } from '../../icons/success-icon/success-icon.component';
import { WarningIconComponent } from '../../icons/warning-icon/warning-icon.component';
import { InfoIconComponent } from '../../icons/info-icon/info-icon.component';
import { ErrorIconComponent } from '../../icons/error-icon/error-icon.component';
import { ButtonComponent } from '../../../globals/button/button/button.component';
import { NavigationLinkComponent } from '../../navigation/navigation-link/navigation-link.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'cp-message-design-b-global',
    template: `
    @if ((messages$ | async); as message) {
      @if (message && (
        message.type === MessageTypeEnum.GLOBAL
        || message.type === MessageTypeEnum.GLOBAL_WITH_ACTION
        || message.type === MessageTypeEnum.AUTH
        )) {
        <div
          data-cypress="globaleMessageContainer"
          class="MessageDesignB-container-global"
          (click)="onClear()">
          <div data-cypress="MessageGlobalNavigationLinkBtn"
            class="MessageDesignB-message MessageDesignB-message-global-centered">
            <div class="MessageDesignB-messageIconContainer">
              @switch (message.severity) {
                @case (MessageSeverity.SUCCESS) {
                  <cp-success-icon></cp-success-icon>
                }
                @case (MessageSeverity.WARNING) {
                  <cp-warning-icon></cp-warning-icon>
                }
                @case (MessageSeverity.DATA_CHANGE) {
                  <cp-info-icon></cp-info-icon>
                }
                @case (MessageSeverity.ERROR) {
                  <cp-error-icon></cp-error-icon>
                }
              }
            </div>
            <div class="CP_flexColumn" style="white-space: pre-line">
              {{ message.translationCode | translate }}
              @if (message?.subMessageTranslationCode) {
                <div class="CP_flexAway FontSize_Rem_0_688 BasisGrotesqueProRegular CP_design-b-light-grey-blue-two"
                  style="overflow-wrap: break-word; max-width: 25rem">
                  {{ message.subMessageTranslationCode | translate }}
                </div>
              }
            </div>
            @if (message.actionButtonType) {
              @switch (message.actionButtonType) {
                @case (MessageActionButtonTypeEnum.PRIMARY_BUTTON) {
                  @if (message.type === MessageTypeEnum.GLOBAL_WITH_ACTION && message.actionButtonText && message.onActionFunction) {
                    <cp-button [size]="ButtonSize.MEDIUM"
                      (buttonClick)="onAction(message)"
                      [text]="message.actionButtonText | translate"
                    class="MessageDesignB-actionBtn"></cp-button>
                  }
                }
                @case (MessageActionButtonTypeEnum.PRIMARY_BUTTON_NEGATIVE) {
                  @if (message.type === MessageTypeEnum.GLOBAL_WITH_ACTION && message.actionButtonText && message.onActionFunction) {
                    <cp-button [size]="ButtonSize.MEDIUM"
                      [style]="ButtonStyle.PRIMARY_NEGATIVE"
                      (buttonClick)="onAction(message)"
                      [text]="message.actionButtonText | translate"
                    class="MessageDesignB-actionBtn"></cp-button>
                  }
                }
                @case (MessageActionButtonTypeEnum.SECONDARY_BUTTON) {
                  @if (message.type === MessageTypeEnum.GLOBAL_WITH_ACTION && message.actionButtonText && message.onActionFunction) {
                    <cp-button [size]="ButtonSize.MEDIUM"
                      [style]="ButtonStyle.SECONDARY"
                      (buttonClick)="onAction(message)"
                      [text]="message.actionButtonText | translate"
                    class="MessageDesignB-actionBtn"></cp-button>
                  }
                }
                @case (MessageActionButtonTypeEnum.SECONDARY_BUTTON_NEGATIVE) {
                  @if (message.type === MessageTypeEnum.GLOBAL_WITH_ACTION && message.actionButtonText && message.onActionFunction) {
                    <cp-button [size]="ButtonSize.MEDIUM"
                      [style]="ButtonStyle.SECONDARY_NEGATIVE"
                      (buttonClick)="onAction(message)"
                      [text]="message.actionButtonText | translate"
                    class="MessageDesignB-actionBtn"></cp-button>
                  }
                }
                @case (MessageActionButtonTypeEnum.LINK) {
                  <cp-navigation-link [routeType]="message.actionButtonRoute"
                    [customStyle]="{margin: '0 1rem 0 0'}"
                    customText="DESIGN_B.NAVIGATION.VIEW"
                  [routeId]="message.actionButtonRouteId"></cp-navigation-link>
                }
              }
            }
            @if (message.multipleErrorMessages && message.multipleErrorMessages.length !== 0) {
              <div (click)="onClickMultipleErrorMessages($event)">
                {{ message.multipleErrorMessages.length + ' Fehler(n)' }}
                <fa-icon [icon]="faCaretDown"
                  class="CP_design-b-light-grey-blue-two">
                </fa-icon>
              </div>
              <p-overlayPanel appendTo="body"
                styleClass="CustomPrimeNg_overlayPanel"
                [showCloseIcon]="false"
                [style]="{top: '1rem'}"
                [baseZIndex]="9999"
                #multipleErrorOverlay
                (onHide)="isMultipleErrorMessageVisible = false">
                <div class="">
                  @for (errorMsg of message.multipleErrorMessages; track errorMsg) {
                    <div
                      class="BasisGrotesqueProBold FontSize_Rem_0_75">
                      {{ errorMsg | translate }}
                    </div>
                  }
                </div>
              </p-overlayPanel>
            }
            @if (!message.actionButtonType) {
              <div class="MessageActionButtonSpacer">
              </div>
            }
          </div>
        </div>
      }
    }
    `,
    styleUrls: ['../message-design-b.component.scss'],
    imports: [SuccessIconComponent, WarningIconComponent, InfoIconComponent, ErrorIconComponent, ButtonComponent, NavigationLinkComponent, FaIconComponent, OverlayPanelModule, AsyncPipe, TranslateModule]
})
export class MessageDesignBGlobalComponent {
  MessageTypeEnum = MessageTypeEnum;
  MessageActionButtonTypeEnum = MessageActionButtonTypeEnum;
  MessageSeverity = MessageSeverity;
  BasicButtonIconColor = BasicButtonIconColor;
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonStyle = ButtonStyle;
  protected readonly faCaretDown = faCaretDown;

  @Input()
  onlyAuthMessages: boolean = false;

  @ViewChild("multipleErrorOverlay") multipleErrorOverlay: OverlayPanel;

  messages$: Observable<MessageModel> = this.messageService.messages$
    .pipe(
      filter(message =>
        !this.onlyAuthMessages
        || !message
        || message.type === MessageTypeEnum.AUTH
      )
    );

  isMultipleErrorMessageVisible: boolean = false;

  constructor(public messageService: GlobalMessageClientService) {
  }

  // region Functions
  onAction(message: MessageModel): void {
    message.onActionFunction();
    this.messageService.clear();
  }

  onClear(): void {
    this.messageService.clear();
  }
  // endregion

  onClickMultipleErrorMessages(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.isMultipleErrorMessageVisible = !this.isMultipleErrorMessageVisible;
    this.multipleErrorOverlay.toggle(event);
  }
}
